import { render, staticRenderFns } from "./AccountsClassification.vue?vue&type=template&id=0d2f5131&"
import script from "./AccountsClassification.vue?vue&type=script&lang=js&"
export * from "./AccountsClassification.vue?vue&type=script&lang=js&"
import style0 from "./AccountsClassification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports